<template>
  <div class="mb-5">
    <MarketOverallIncomeComponent :isMainLoading="isMainLoading" :tabType="tab"/>
  </div>
</template>

<script>
import MarketOverallIncomeComponent from "@/components/MarketOverallIncome.component";
export default {
  components: {
    MarketOverallIncomeComponent
  },
  props: {
    isMainLoading: Boolean
  },
  data() {
    return {
      tab: this.$globalCurrencyCode
    }
  },
};
</script>